import {
  GET_RESTAURANT,
  SET_MEALS,
  SET_RESTAURANT,
  EDIT_BASIC_INFO,
  EDIT_PAPERS,
  EDIT_MEALS,
  SET_PROFIT_MARGINS,
  SET_ID,
  SET_RESTAURANT_ID
} from "../utilities/constants";
import { restaurant } from "../models/model";
import axios from "axios";
const httpClient = axios.create();
httpClient.defaults.timeout = 90000;
axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';

export const createChefBasic = (restaurant) => async (dispatch) => {
  const response = await axios.post('/api/newrest/create_chef_basic', restaurant);
  const { data } = response;
  const { restaurant_id, _id } = data._doc
  console.log(restaurant_id, _id)
  dispatch({ type: SET_RESTAURANT, payload: data._doc });
  dispatch({ type: SET_ID, payload: _id });
  dispatch({ type: SET_RESTAURANT_ID, payload: restaurant_id });
};

export const createRestaurantDocument = (id, documents) => async (dispatch) => {
  const formData = new FormData(); // Create a new FormData instance
  for (const key in documents) {
    formData.append(key, documents[key]);
  }
  try {
    const response = await httpClient.post(`/api/newrest/upload_docs/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the proper content type for files
      },
    });
    const { data } = response;
    const { restaurant_id, _id } = data._doc;
    console.log(restaurant_id, _id);
  } catch (error) {
    // Handle errors here
    console.error('Error uploading documents:', error);
  }
};


export const updateRestaurant = (id, document) => async (dispatch) => {
  const response = await httpClient.put(`/api/newrest/${id}`, document)
  const { data } = response
  dispatch({ type: SET_RESTAURANT, payload: data.data })
}

export const setMeals = (index) => async (dispatch) => {
  dispatch({ type: SET_MEALS, payload: restaurant.meals[index] });
};

export const updateMeals = (id, meals) => async (dispatch) => {
  await console.log(`Restaurant id ${id} has meals ${meals}`)
};

export const getRestaurant = (id) => async (dispatch) => {
  const response = await httpClient.get("/api/newrest/" + id);
  const data = await response.data;
  console.log(data)
  dispatch({ type: SET_RESTAURANT, payload: data });
};

export const getAllRestaurant = () => async (dispatch) => {
  const response = await httpClient.get("/api/newrest/");
  const restaurant = await response.data;
  dispatch({ type: GET_RESTAURANT, payload: restaurant, });
};

export const getRestaurants = async () => {
  const response = await httpClient.get("/api/newrest/");
  const { data } = response
  return data
};

export const getProfitMargin = async () => {
  const response = await httpClient.get('/api/plans/getProfitMargin')
  const { data } = response
  return data
}

export const getCuisines = async () => {
  const response = await httpClient.get('/api/cuisine');
  const { data } = response
  return data
}
export const getCommission = async () => {
  const response = await httpClient.get('/api/checkout/getcommission');
  const { commission } = response.data
  return commission
}

export const saveCuisine = async (cuisine) => {
  const response = await httpClient.post('/api/cuisine', cuisine)
  const { msg } = response.data
  return msg
}

export const editBasicInfo = (id, data) => {
  return { type: EDIT_BASIC_INFO, payload: data };
};

export const editDocuments = (docs, papers) => {
  return { type: EDIT_PAPERS, payload: { documents: docs, papers: papers } };
};

export const editMealsInfo = (data) => {
  return { type: EDIT_MEALS, payload: { meals: data } };
};

export const fetchProfitMargins = () => async (dispatch) => {
  const response = await axios.get('/api/plans/getProfitMargin')
  const { data } = response
  dispatch({ type: SET_PROFIT_MARGINS, payload: data })
}

